/**
 *  @class
 *  @function Pagination
 */

// ALOLA 1-oct-2026: el chequeo miraba 'pagination' (nombre que no existe) en vez de 'pagination-theme'.
if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // ALOLA 1-oct-2026: arranca desde la página en la que se entró (?page=2 de Google o de links viejos).
      // Antes siempre pedía la 2 y, si se entraba por ?page=2, duplicaba los 48 productos.
      this.first = parseInt(new URLSearchParams(document.location.search).get('page'), 10) || 1;
      this.i = this.first + 1;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
      if (this.isLast()) {
        this.finish();
      }
      this.onPageHide = this.saveState.bind(this);
      window.addEventListener('pagehide', this.onPageHide);
      this.restoreState();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.onPageHide) {
        window.removeEventListener('pagehide', this.onPageHide);
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    // ALOLA 1-oct-2026: el botón "Carga más" se quedaba visible después de la última página
    // (solo se ocultaba si la respuesta no traía grilla). Con data-pages se oculta al terminar.
    isLast() {
      let pages = parseInt(this.dataset.pages, 10);
      return pages && this.i > pages;
    }
    finish() {
      if (this.observer) {
        this.observer.unobserve(this);
      }
      if (this.button) {
        this.button.classList.add('visually-hidden');
      }
    }
    // ALOLA 1-oct-2026: "Carga más" no cambia la URL, así que al entrar a una ficha y volver atrás
    // la colección se recargaba con solo la primera página y arriba de todo. Al salir se guarda
    // hasta qué página se cargó y dónde estaba; al volver atrás se recuperan las dos cosas.
    stateKey() {
      return 'alola-pag:' + document.location.pathname + document.location.search;
    }
    saveState() {
      try {
        if (this.i - 1 > this.first) {
          sessionStorage.setItem(this.stateKey(), JSON.stringify({
            hasta: this.i - 1,
            y: Math.round(window.scrollY),
            t: Date.now()
          }));
        } else {
          sessionStorage.removeItem(this.stateKey());
        }
      } catch (e) {}
    }
    restoreState() {
      if (Pagination.restoreDone) {
        return;
      }
      Pagination.restoreDone = true;
      let nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null,
        back = nav ? nav.type === 'back_forward' : (performance.navigation && performance.navigation.type === 2),
        state = null;
      if (!back) {
        return;
      }
      try {
        state = JSON.parse(sessionStorage.getItem(this.stateKey()));
      } catch (e) {}
      if (!state || !state.hasta || Date.now() - state.t > 30 * 60 * 1000) {
        return;
      }
      let base = this,
        animations = base.animations_enabled;
      base.animations_enabled = false;
      let done = function () {
        base.animations_enabled = animations;
        let html = document.documentElement,
          behavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, state.y);
        html.style.scrollBehavior = behavior;
      };
      let next = function () {
        if (base.i > state.hasta || base.isLast()) {
          done();
          return;
        }
        let from = base.i,
          request = base.loadProducts();
        if (!request) {
          base.animations_enabled = animations;
          return;
        }
        request.then(() => {
          if (base.i > from) {
            next();
          } else {
            base.animations_enabled = animations;
          }
        });
      };
      next();
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      return fetch(url)
        .then(response => response.text())
        // ALOLA 1-oct-2026: si falla la red, el botón vuelve a quedar usable (antes se trababa).
        // El catch va solo sobre el fetch para no repetir una página que sí se agregó.
        .catch(() => null)
        .then((responseText) => {
          if (responseText === null) {
            base.i--;
            base.removeAttribute('loading');
            return;
          }
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      // ALOLA 1-oct-2026: los banners de la grilla (3 cuotas, Genesis, etc.) solo en la primera tanda;
      // antes se repetían todos después del producto 48 al tocar "Carga más".
      let products = grid_to_replace.querySelectorAll('.column:not(.promotion-column)');

      // ALOLA 17-oct-2026 (Ana): cada tanda son 48 cuadros contando los banners. En la 1.ª tanda los productos
      // que no entraron por los banners quedaron guardados (data-alola-resto): salen primero; de lo que llega
      // se muestran solo los que completan la tanda y el resto se guarda para la siguiente. En la última, todo.
      let celdas = parseInt(base.dataset.celdas, 10) || products.length,
        ultima = base.isLast(),
        visibles = 0,
        guardados = this.grid.querySelectorAll('.column[data-alola-resto]');
      for (var g = 0; g < guardados.length; g++) {
        guardados[g].removeAttribute('data-alola-resto');
        guardados[g].style.display = '';
        visibles++;
      }
      let mostrados = [];
      for (var i = 0; i < products.length; i++) {
        let li = products[i];
        li.removeAttribute('data-alola-resto');
        li.style.display = '';
        if (!ultima && visibles >= celdas) {
          li.setAttribute('data-alola-resto', '');
          li.style.display = 'none';
        } else {
          visibles++;
          mostrados.push(li);
        }
        this.grid.appendChild(li);
      }
      products = mostrados.concat(Array.prototype.slice.call(guardados));
      if (base.isLast()) {
        base.finish();
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            if (typeof StampedFn !== "undefined" && typeof StampedFn.loadBadges !== "undefined") {
              StampedFn.loadBadges();
            }
          }
        });
      } else {
        base.removeAttribute('loading');
        if (typeof StampedFn !== "undefined" && typeof StampedFn.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
  // Solo la colección con la que se cargó la página recupera su estado (no las que trae un filtro después).
  Pagination.restoreDone = true;
}
